import React, { useState } from 'react'
import { uuid } from 'uuidv4'
import { Input } from './'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Password = props => {           
    const [type, setType] = useState("password");
    const togglePassword = () => type === "password" ? setType("text") : setType("password");

    const customProps = Object.assign({}, { "defaultValue": "", "type": type, "autocomplete": uuid() }, props);

    return (
        <div className="input-group">
            <Input {...customProps} />
            <div className="input-group-append">
                <button className="btn btn-outline-secondary" type="button" onClick={togglePassword}>
                    <FontAwesomeIcon icon={type === "password" ? "eye-slash" : "eye"} />
                </button>
            </div>
        </div>        
    )
}

export default Password;